import React from "react";
import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { getSettingState } from "../../../../redux/features/settingSlice";
import CustomButton from "./../../CustomButton/index";

const LoginFooter = ({ type, disabled }) => {
  const navigate = useNavigate();
  const { loadNavigation, customModal, playListModal } =
    useSelector(getSettingState);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        p: "16px",
        height: "72px",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "white.main",
        zIndex: 1,
      }}
    >
      {loadNavigation && !customModal && !playListModal && (
        <Box
          sx={{
            width: "100%",
            position: "absolute",
            left: 0,
            right: 0,
            top: "-3px",
            zIndex: 4,
          }}
        >
          <LinearProgress color='primary' />
        </Box>
      )}

      <CustomButton
        title='Skip'
        onClick={() => navigate("/profile")}
        fSize='16px'
        width='50%'
        height='40px'
        bShadow='0px'
        bgColor='white.main'
        mRight='10px'
      />

      <CustomButton
        disabled={disabled}
        title={type === "editCategory" ? "Done" : "Next"}
        fSize='16px'
        width='50%'
        height='40px'
        bShadow='2px'
        bgColor='primary.main'
        color='#212121'
        submit
      />
    </Box>
  );
};

export default LoginFooter;
